import React, { useState } from "react";
import {
  Typography,
  Grid,
  Paper,
  Card,
  CardMedia,
  Button,
  Checkbox,
  Box,
} from "@mui/material";
import ImageViewDialog from "../mui/imageViewDialog";
import { IMAGE_BASE_URL } from "../data/API_LINKS";
import ConfirmationDialog from "./ConfirmationDialog";
import {
  activeKitchen,
  approveKitchen,
  rejectKitchen,
  suspendKitchen,
} from "../data/API";

export const imageCardStyle = {
  borderRadius: "7px",
  boxShadow: 3,
  height: "90%",
  width: "34%",
  marginX: "10px",
};
export const cardMediaStyle = {
  borderRadius: "10px",
  height: "85%",
};

const KitchenProfileView = ({ data, setWarning, setLoading }) => {
  const [copyData, setCopyData] = useState(data);
  console.log("setStateCalled", copyData);

  const [isRejectVisible, setRejectVisiblity] = useState(false);
  const [isSuspendVisible, setSuspendVisiblity] = useState(false);
  const [isActiveVisible, setActiveVisiblity] = useState(false);
  const [isApproveVisible, setApproveVisiblity] = useState(false);

  const [imageToView, setImageToView] = useState(null);

  function handleOnNoClick() {
    setRejectVisiblity(false);
    setSuspendVisiblity(false);
    setActiveVisiblity(false);
    setApproveVisiblity(false);
  }
  function handleOnSubmit(o, msg) {
    handleOnNoClick();

    console.log({
      type: o,
      message: msg,
    });

    if (o === "reject") {
      setLoading(true);
      setWarning(false);
      rejectKitchen(copyData?.id, msg === "" ? "N/A" : msg, (err, d) => {
        console.log("New DATA", { err: err, data: d });
        console.log("Old DATA", { err: err, data: copyData });
        if (err) {
          setWarning(true);
          setLoading(false);
        } else {
          setWarning(false);
          setLoading(false);
          setCopyData(d);
        }
      });
    }
    if (o === "approve") {
      setLoading(true);
      setWarning(false);
      approveKitchen(copyData?.id, msg === "" ? "N/A" : msg, (err, d) => {
        console.log("New DATA", { err: err, data: d });
        console.log("Old DATA", { err: err, data: copyData });
        if (err) {
          setWarning(true);
          setLoading(false);
        } else {
          setWarning(false);
          setLoading(false);
          setCopyData(d);
        }
      });
    }
    if (o === "suspend") {
      setLoading(true);
      setWarning(false);
      suspendKitchen(copyData?.id, msg === "" ? "N/A" : msg, (err, d) => {
        console.log("New DATA", { err: err, data: d });
        console.log("Old DATA", { err: err, data: copyData });
        if (err) {
          setWarning(true);
          setLoading(false);
        } else {
          setWarning(false);
          setLoading(false);
          setCopyData(d);
        }
      });
    }
    if (o === "active") {
      setLoading(true);
      setWarning(false);
      activeKitchen(copyData?.id, msg === "" ? "N/A" : msg, (err, d) => {
        if (err) {
          setWarning(true);
          setLoading(false);
        } else {
          setWarning(false);
          setLoading(false);
          setCopyData(d);
        }
      });
    }
  }

  return (
    <div
      style={{
        width: "100%",
        height: window.innerHeight - 100,

        overflowY: "scroll",
      }}
    >
      <ConfirmationDialog
        onNoClick={handleOnNoClick}
        onYesClick={(msg) => handleOnSubmit("reject", msg)}
        title={"Reject Kitchen Request"}
        visible={isRejectVisible}
      />

      <ConfirmationDialog
        onNoClick={handleOnNoClick}
        onYesClick={(msg) => handleOnSubmit("approve", msg)}
        title={"Approve Kitchen Request"}
        visible={isApproveVisible}
      />
      <ConfirmationDialog
        onNoClick={handleOnNoClick}
        onYesClick={(msg) => handleOnSubmit("active", msg)}
        title={"Active Suspended Kitchen"}
        visible={isActiveVisible}
      />
      <ConfirmationDialog
        onNoClick={handleOnNoClick}
        onYesClick={(msg) => handleOnSubmit("suspend", msg)}
        title={"Suspend Active Vendor"}
        visible={isSuspendVisible}
      />

      <ImageViewDialog
        open={imageToView != null}
        imageUrl={imageToView}
        onClose={() => setImageToView(null)}
      />
      <div
        style={{
          height: "240px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "70%",
        }}
      >
        <Card
          onClick={() => setImageToView(IMAGE_BASE_URL + copyData.ic_photo)}
          sx={imageCardStyle}
        >
          <CardMedia
            component="img"
            src={IMAGE_BASE_URL + copyData.ic_photo}
            alt="NRIC Photo"
            style={cardMediaStyle}
          />

          <h6 className="my-2 text-center text-black">NRIC Photo</h6>
        </Card>
        {copyData.account_type === "company" ? (
          <Card
            onClick={() =>
              setImageToView(IMAGE_BASE_URL + copyData.company_document)
            }
            sx={imageCardStyle}
          >
            <CardMedia
              component="img"
              src={IMAGE_BASE_URL + copyData.company_document}
              alt="Company Document Photo"
              style={cardMediaStyle}
            />
            <h6 className="my-2 text-center text-black">Company Document</h6>
          </Card>
        ) : null}

        <Card
          sx={imageCardStyle}
          onClick={() =>
            setImageToView(IMAGE_BASE_URL + copyData.bank_statement)
          }
        >
          <CardMedia
            component="img"
            src={IMAGE_BASE_URL + copyData?.bank_statement}
            alt="Bank Statement Photo"
            style={cardMediaStyle}
          />
          <h6 className="my-2 text-center text-black">Bank Statement</h6>
        </Card>
      </div>
      <Paper
        elevation={2}
        style={{
          marginTop: "16px",
          padding: "16px",
          height: "auto",
          width: "100%",
          display: "flex",
          // overflowY:'scroll',
          flexDirection: "row",
        }}
      >
        <Grid container sx={{ flex: 1.6 }} spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Vendor Information</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Vendor Name
            </Typography>
            <Typography variant="body1">
              {copyData?.full_name} <Checkbox />
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle" style={{ fontWeight: 600 }}>
              Region And Subregion
            </Typography>
            <Typography variant="body1">
              {copyData?.region + " > " + copyData.subregion} <Checkbox />
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Tiktok
            </Typography>
            <Typography variant="body1">
              {copyData?.tiktok_link == null ? "Not Mentioned" : ""}
              {copyData?.tiktok_link && (
                <Button
                  onClick={() => {
                    window.open(copyData?.tiktok_link, "_blank");
                  }}
                  variant="contained"
                  sx={{ borderRadius: 10, paddingX: 2, fontSize: 10 }}
                >
                  Open Link
                </Button>
              )}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Facebook
            </Typography>
            <Typography variant="body1">
              {copyData?.fb_link == null ? "Not Mentioned" : ""}
              {copyData?.fb_link && (
                <Button
                  onClick={() => {
                    window.open(copyData?.fb_link, "_blank");
                  }}
                  variant="contained"
                  sx={{ borderRadius: 10, paddingX: 2, fontSize: 10 }}
                >
                  Open Link
                </Button>
              )}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Instagram
            </Typography>
            <Typography variant="body1">
              {copyData?.insta_link == null ? "Not Mentioned" : ""}
              {copyData?.insta_link && (
                <Button
                  onClick={() => {
                    window.open(copyData?.insta_link, "_blank");
                  }}
                  variant="contained"
                  sx={{ borderRadius: 10, paddingX: 2, fontSize: 10 }}
                >
                  Open Link
                </Button>
              )}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Youtube
            </Typography>
            <Typography variant="body1">
              {copyData?.youtube_link == null ? "Not Mentioned" : ""}
              {copyData?.youtube_link && (
                <Button
                  onClick={() => {
                    window.open(copyData?.youtube_link, "_blank");
                  }}
                  variant="contained"
                  color="error"
                  sx={{ borderRadius: 10, paddingX: 2, fontSize: 10 }}
                >
                  Open Youtube
                </Button>
              )}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Owner's Full Name
            </Typography>
            <Typography variant="body1">
              {copyData?.nric_no} <Checkbox />
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Owner's NRIC #
            </Typography>
            <Typography variant="body1">
              {copyData?.nric_no} <Checkbox />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Bank Information</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Bank Name:
            </Typography>
            <Typography variant="body1">
              {copyData?.bank_name} <Checkbox />
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              Account Number:
            </Typography>
            <Typography variant="body1">
              {copyData?.account_number}
              <Checkbox />
            </Typography>
          </Grid>
          {copyData?.account_type == "company"
            ? [
                <Grid item xs={12}>
                  <Typography variant="h6">Company Information</Typography>
                </Grid>,
                <Grid item xs={6}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                    Company Name:
                  </Typography>
                  <Typography marginBottom={"40px"} variant="body1">
                    {copyData?.company_name}
                    <Checkbox />
                  </Typography>
                </Grid>,
                <Grid item xs={6}>
                  <Typography variant="subtitle1">
                    Registration Number:
                  </Typography>
                  <Typography variant="body1">
                    {copyData?.company_reg_number}
                    <Checkbox />
                  </Typography>
                </Grid>,
              ]
            : null}
        </Grid>
        {copyData?.status === "pending" ? (
          <div
            style={{
              flex: 0.4,
              justifyContent: "center",
              textAlign: "center",
              paddingTop: "10%",
            }}
          >
            <div
              style={{ marginBottom: "30px", fontSize: "16px", color: "green" }}
            >
              Status{" "}
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  fontWeight: "500",
                  fontVariantCaps: true,
                }}
              >
                {copyData?.status?.toUpperCase()}
              </p>
            </div>

            <Button
              onClick={() => setApproveVisiblity(true)}
              sx={{ marginY: "6px", marginX: "5px" }}
              color={"success"}
              variant="contained"
            >
              Approve
            </Button>
            <Button
              onClick={() => setRejectVisiblity(true)}
              color={"error"}
              sx={{ marginY: "6px", marginX: "5px" }}
              variant="contained"
            >
              Reject
            </Button>
          </div>
        ) : copyData?.status === "approved" ? (
          <div
            style={{
              flex: 0.4,
              justifyContent: "center",
              textAlign: "center",
              paddingTop: "10%",
            }}
          >
            <div
              style={{ marginBottom: "30px", fontSize: "16px", color: "green" }}
            >
              Status{" "}
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  fontWeight: "500",
                  fontVariantCaps: true,
                }}
              >
                {copyData?.status?.toUpperCase()}
              </p>
            </div>

            <Button
              onClick={() => setSuspendVisiblity(true)}
              sx={{ marginY: "6px", marginX: "5px" }}
              color={"error"}
              variant="contained"
            >
              Suspend
            </Button>
          </div>
        ) : (
          <div
            style={{
              flex: 0.5,
              justifyContent: "center",
              textAlign: "center",
              paddingTop: "5%",
            }}
          >
            <div
              style={{ marginBottom: "30px", fontSize: "16px", color: "green" }}
            >
              Status{" "}
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  fontWeight: "500",
                  fontVariantCaps: true,
                }}
              >
                {copyData?.status?.toUpperCase()}
              </p>
            </div>

            <Button
              onClick={() => setActiveVisiblity(true)}
              sx={{ marginY: "6px", marginX: "5px" }}
              color={"success"}
              variant="contained"
            >
              Active
            </Button>
          </div>
        )}
      </Paper>
    </div>
  );
};

export default KitchenProfileView;
